import React from "react";
import classes from "./GameOverModal.module.css";

const WrongWordModal = ({closeWrongWordModal}) => {
  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>
        <div className={classes.modal_img_container}>
          <img
            className={classes.modal_img}
            src="/assets/images/oops.png"
            alt="result"
          />
        </div>
        <div className={classes.modal_description}>
          {/* <h1>OOPS...</h1> */}
          <p>The Entered Word is not in word dictionary!</p>
        </div>

        <div className={classes.buttons_container}>
          {/* <button
            type="button"
            className={classes.play_btn}
            onClick={closeModalHandler}
          >
            Close
          </button> */}
          <button
            type="button"
            className={classes.back_btn}
            onClick={closeWrongWordModal}
          >
            Close!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WrongWordModal;
